import {
  queryAuthorId,
  queryAuthor,
  queryAuthorIntegration,
} from '@/graphql/wordpress/query/author.js'

export default {
  async asyncData({ app, query, error, params }) {
    try {
      const pageKey = 'editorial-staff'
      const pageItem = app.$configuration.pages.list.find(
        (page) => pageKey === page.key
      )

      if (!pageItem) {
        console.error(`[${pageKey}] doesn't exist in the pages configuration`)
        return error({
          statusCode: 500,
        })
      }

      // Ritorno l'ID dell'autore
      const [authorIds] = await app.apolloProvider.defaultClient
        .query({
          query: queryAuthorId,
          variables: {
            nicename: params.author,
          },
        })
        .then(({ data }) => data.users?.nodes)

      if (!authorIds) {
        return error({ statusCode: 404 })
      }

      const requestAuthor = await app.apolloProvider.defaultClient
        .query({
          query: queryAuthor,
          variables: {
            idAuthor: authorIds.id,
            startCursorAuthor: query.prev || null,
            lastAuthor: query.prev ? 10 : null,
            endCursorAuthor: query.next || null,
            firstAuthor: !query.prev ? 10 : null,
          },
        })
        .then(({ data }) => data)

      if (!requestAuthor.user) {
        return error({ statusCode: 404 })
      }

      const page = requestAuthor

      return {
        page,
        pageItem,
        authorIds,
      }
    } catch (e) {
      console.error(e)
      // return error({ statusCode: 500 })
    }
  },
  computed: {
    seo() {
      const seo = this.$generateTags(
        {
          ...this.page.user.seo,
        },
        this.$i18n
      )
      return seo
    },
  },
  methods: {
    async integrateQuery() {
      try {
        //  Dato che le query sono lente integro i dati del post con una query client side richiamando gli ADV e la descrizione che sono le parti più onerose per la query
        const requestAuthorIntegration = await this.$apollo
          .query({
            query: queryAuthorIntegration,
            variables: {
              uriPage: this.pageItem.wpUri,
              idAuthor: this.authorIds.id,
              startCursorAuthor: this.$route.query.prev || null,
              lastAuthor: this.$route.query.prev ? 10 : null,
              endCursorAuthor: this.$route.query.next || null,
              firstAuthor: !this.$route.query.prev ? 10 : null,
            },
          })
          .then(({ data }) => data)

        // Assegno gli ADV
        /* this.page = {
          ...this.page,
          pageBy: requestAuthorIntegration.pageBy,
        } */
        this.page = requestAuthorIntegration
      } catch (e) {
        console.error(e)
        // return this.$nuxt.context.error({ statusCode: 500 })
      }
    },
  },
  async mounted() {
    await this.integrateQuery()
  },
  async updated() {
    if (!this.page?.pageBy?.advertising) await this.integrateQuery()
  },
  watchQuery: ['prev', 'next'],
}
